import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[stopClickPropagation]',
    standalone: false
})
export class StopClickPropagationDirective {
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    event.stopPropagation();
    // event.preventDefault();
  }
}
